import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { styled } from '@mui/material/styles';
import ColorSF2 from '../../styles/common/ColorSF2';

const CustomizedButtonGroup = styled(ButtonGroup)({
  '& .MuiButtonGroup-grouped': {
    border: `1px solid ${ColorSF2.mediumGray}`,
  },
});

const CustomizedButton = styled(Button)(props => ({
  backgroundColor: props.selected ? ColorSF2.navyBlue : ColorSF2.white,
  border: props.selected
    ? `1px solid ${ColorSF2.mediumGray} !important`
    : 'inherit',
  color: props.selected ? ColorSF2.white : ColorSF2.black,
  width: '80px',
  height: '32px',
  '&:hover': {
    backgroundColor: ColorSF2.navyBlue,
    color: ColorSF2.white,
    border: `1px solid ${
      (props.selected && '#405289') || '#405289'
    } !important`,
    opacity: 0.8,
  },
}));

const createButtons = (length, labels, selected, setValue) => {
  const items = [];
  for (let i = 1; i <= length; i += 1) {
    const label = (labels.length >= i && labels[i - 1]) || '';
    items.push(
      <CustomizedButton
        className={selected.includes(i) && 'GroupButtonSelected'}
        key={`group_button_${i}`}
        disableRipple
        selected={selected.includes(i)}
        onClick={() => setValue(i)}
      >
        {label}
      </CustomizedButton>,
    );
  }
  return items;
};

const GroupButtons = ({ length, labels, selected, setSelected }) => {
  const setValue = value => {
    if (selected.includes(value)) {
      const newSelected = selected.filter(data => data !== value);
      setSelected(newSelected);
      return;
    }
    const newSelected = selected.slice();
    newSelected.push(value);
    setSelected(newSelected);
  };
  return (
    <CustomizedButtonGroup variant="outlined">
      {createButtons(length, labels, selected, setValue)}
    </CustomizedButtonGroup>
  );
};
GroupButtons.propTypes = {
  length: PropTypes.number.isRequired,
  labels: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
};
export default GroupButtons;
